// extracted by mini-css-extract-plugin
export default {"card":"LoaderSkeleton_card__zfbMt"};